import { render } from "./FlexGrow.vue?vue&type=template&id=2b525144&scoped=true&ts=true"
import script from "./FlexGrow.vue?vue&type=script&lang=ts"
export * from "./FlexGrow.vue?vue&type=script&lang=ts"

import "./FlexGrow.vue?vue&type=style&index=0&id=2b525144&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b525144"]])

export default __exports__